import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Flex, Button, getPaletteColor } from 'pcln-design-system'
import FooterHint from './FooterHint'

const FooterFlex = styled(Flex)`
  background: ${getPaletteColor('background.lightest')};
  border-top: 1px solid ${getPaletteColor('border.base')};
  ${(props) => props.theme.mediaQueries[1]} {
    box-shadow: ${(props) => (props.boxShadow ? props.theme.boxShadows[3] : 'none')};
    height: auto;
  }
  z-index: 1000;
`

const DoneBtn = styled(Button)`
  background: transparent;
  color: ${getPaletteColor('primary.base')};

  &:hover {
    background: ${getPaletteColor('background.light')};
    color: ${getPaletteColor('primary.dark')};
  }
`

export default function Footer(props) {
  const { dismissCalendar } = props

  return (
    <FooterFlex p={2} width={[1]} justifyContent='space-between' alignItems='center'>
      <FooterHint />
      <DoneBtn onClick={dismissCalendar} size='small' aria-label='Dismiss calendar'>
        Done
      </DoneBtn>
    </FooterFlex>
  )
}

Footer.propTypes = {
  dismissCalendar: PropTypes.func,
}
